import { render, staticRenderFns } from "./ClinicInformationInputArea.vue?vue&type=template&id=523c790a&scoped=true&"
import script from "./ClinicInformationInputArea.vue?vue&type=script&lang=js&"
export * from "./ClinicInformationInputArea.vue?vue&type=script&lang=js&"
import style0 from "./ClinicInformationInputArea.vue?vue&type=style&index=0&id=523c790a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c790a",
  null
  
)

export default component.exports